<template>
    <div class="rankRewardInner">
        <div class="parentTabIn" style="top: 67px;">
            <ul class="nav nav-tabs" role="tablist" style="justify-content: center;">
                <li class="nav-item" style="display: none;">
                    <div class="nav-link" :class="{ 'active': activeTab === 'charmTab' }"
                        @click="changeTab('charmTab')" data-toggle="tab" href="#charmTab" role="tab">Charm</div>
                </li>
                <li class="nav-item" style="display: none;">
                    <div class="nav-link" :class="{ 'active': activeTab === 'richTab' }" @click="changeTab('richTab')"
                        data-toggle="tab" href="#richTab" role="tab">Rich</div>
                </li>
                <li class="nav-item" style="display: none;">
                    <div class="nav-link" :class="{ 'active': activeTab === 'roomTab' }" @click="changeTab('roomTab')"
                        data-toggle="tab" href="#roomTab" role="tab">Room</div>
                </li>
                <li class="nav-item" style="display: none;">
                    <div class="nav-link" :class="{ 'active': activeTab === 'callTab' }" @click="changeTab('callTab')"
                        data-toggle="tab" href="#callTab" role="tab">Call</div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'agencyTab' }"
                        @click="changeTab('agencyTab')" data-toggle="tab" href="#agencyTab" role="tab">Top Agency
                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'charmTab' }" id="charmTab" role="tabpanel">
                <div class="tab-contentIn" >
                    <weeklyRankRewardsCharm />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'richTab' }" id="richTab" role="tabpanel">
                <div class="tab-contentIn" >
                    <weeklyRankRewardsRich />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'roomTab' }" id="roomTab" role="tabpanel">
                <div class="tab-contentIn" >
                    <weeklyRankRewardsRoom />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'callTab' }" id="callTab" role="tabpanel">
                <div class="tab-contentIn" >
                    <weeklyRankRewardsCall />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'agencyTab' }" id="agencyTab" role="tabpanel">
                <div class="tab-contentIn" >
                    <weeklyRankRewardsAgency />
                </div>
            </div>            
        </div>
    </div>
</template>
<script>
import weeklyRankRewardsCharm from '../RankRewardInfoComponent/weeklyRankRewardsCharm.vue'
import weeklyRankRewardsRich from '../RankRewardInfoComponent/weeklyRankRewardsRich.vue'
import weeklyRankRewardsRoom from '../RankRewardInfoComponent/weeklyRankRewardsRoom.vue'
import weeklyRankRewardsCall from '../RankRewardInfoComponent/weeklyRankRewardsCall.vue'
import weeklyRankRewardsAgency from '../RankRewardInfoComponent/weeklyRankRewardsAgency.vue'
export default {
    name: 'AgencyRankRewardInfoComponent',
    props: {
      currentTab: {
        type: String,
        default: 'agencyTab'
      }
    },
    components: {
        weeklyRankRewardsCharm,
        weeklyRankRewardsRich,
        weeklyRankRewardsRoom,
        weeklyRankRewardsCall,
        weeklyRankRewardsAgency
    },
    data() {
        return {
            activeTab: this.currentTab,            
        };
    },
    methods: {
        changeTab(tabId) {
            this.activeTab = tabId;
        }
    },    
    mounted() {
        this.isLoadedAgencyTab = true
        
    },
    watch: {
      currentTab(newTab) {
        this.activeTab = newTab;
      }
    },

}
</script>